import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { Col, Container, Row } from "react-bootstrap";
import {
  Box,
  InnerHeading,
  LazyImage,
  MainHeading,
  SpanStyled,
  SpanStyledB,
} from "../../ui/Elements";
import Slider from "react-slick";
import { useTranslation } from "react-i18next";
import { ContactButton } from "../../ui/CustomElements";
import i18n from "../../Languages/INEXT";
import Lightbox from "yet-another-react-lightbox";
import { PrimaryHeading } from "../../ui/Elements";
import {
  OurProjectBg,
  ProjImg1,
  ProjImg2,
  ProjImg3,
  ProjImg4,
  ProjImg5,
  ProjImg6,
  ProjImg7,
  ProjImg8,
} from "../../ui/AllImages";
import { Animate } from "react-simple-animate";
const Projects = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [index, setIndex] = useState(0);
  const sectionRef = useRef(null);
  const [isVisible, setIsVisible] = useState(false);
  const BrandDataConfig = [
    { img: <img src={ProjImg1} alt="client" />, src: ProjImg1 },
    { img: <img src={ProjImg2} alt="client" />, src: ProjImg2 },
    { img: <img src={ProjImg3} alt="client" />, src: ProjImg3 },
    { img: <img src={ProjImg4} alt="client" />, src: ProjImg4 },
  ];
  const BrandDataConfig2 = [
    { img: <img src={ProjImg5} alt="client" />, src: ProjImg5 },
    { img: <img src={ProjImg6} alt="client" />, src: ProjImg6 },
    { img: <img src={ProjImg7} alt="client" />, src: ProjImg7 },
    { img: <img src={ProjImg8} alt="client" />, src: ProjImg8 },
  ];
  const slides = BrandDataConfig.map((item) => ({
    src: item.src,
  }));
const slides2 = BrandDataConfig2.map((item) => ({
    src: item.src,
  }));
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        // When visible, set to true
        if (entry.isIntersecting) {
          setIsVisible(true);
          observer.disconnect(); // run animation once
        }
      },
      {
        threshold: 0.2, // 20% of section visible triggers the animation
      },
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const start =
    i18n.language === "ar"
      ? { clipPath: "inset(0 0 0 100%)" } // Arabic → reveal right → left
      : { clipPath: "inset(0 100% 0 0)" }; // English → reveal left → right
  const end = { clipPath: "inset(0 0% 0 0)" };
  const start2 = { opacity: 0, transform: "translateY(-20px)" };
  const end2 = { opacity: 1, transform: "translateY(0)" };
  const settings = {
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    pauseOnHover: false,

    speed: 2000,
    // autoplaySpeed: 2000,
    // cssEase: "linear",
    // nextArrow: <BrandArrowRight />,
    // prevArrow: <BrandArrowLeft />,
    responsive: [
      {
        breakpoint: 1199,
        
      },
      {
        breakpoint: 1024,
        
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const settings2 = {
    autoplay: true,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 1,
    swipeToSlide: true,
    pauseOnHover: false,
    rtl: true,
    speed: 2000,
    // autoplaySpeed: 2000,
    // cssEase: "linear",
    // nextArrow: <BrandArrowRight />,
    // prevArrow: <BrandArrowLeft />,
    responsive: [
      {
        breakpoint: 1199,
        
      },
      {
        breakpoint: 1024,
        
      },
      {
        breakpoint: 991,
        settings: {
          slidesToShow: 3,
          
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  return (
    <ProjWrp id="prjects">
      <TransformWapper
        className="container-fluid common-space transformFluid"
        ref={sectionRef}
      >
        <Container>
          <Box className="servicesRow row">
            <Col md={12} className="servicesColMain">
              <Row className="">
                <Col md={12}>
                  <Box className="projDescRow row">
                    <Col
                      md={12}
                      lg={6}
                      className="servicesDescCol servicesDescCol1"
                    >
                      {/* <Box className='servicesDescCol1Content'> */}
                      <Animate
                        play={isVisible}
                        duration={1.5}
                        // delay={-0.5}

                        start={start}
                        end={end}
                      >
                        <PrimaryHeading
                          className="main-heading mb-1 projH"
                          color="var(--white)"
                        >
                          {t("projectH")}
                        </PrimaryHeading>
                      </Animate>
                      {/* </Box> */}
                    </Col>
                    <Col
                      md={12}
                      lg={6}
                      className="servicesDescCol servicesDescCol2"
                    >
                      {/* <Box className='servicesDescCol2Content'> */}
                      <Animate
                        play={isVisible}
                        duration={1}
                        delay={0.8}
                        start={start2}
                        end={end2}
                      >
                        <SpanStyled
                          className="d-flex mb-4 projTxt"
                          color="var(--white)"
                          size="36px"
                        >
                          {t("projectT")}
                        </SpanStyled>
                      </Animate>
                      {/* </Box> */}
                    </Col>
                  </Box>
                </Col>
              </Row>
            </Col>
          </Box>
        </Container>
      </TransformWapper>
      <ProjWapper className="container-fluid projFluid">
        <Row>
            <Slider className='align-items-center justify-content-evenly p-0' {...settings}>
                {BrandDataConfig.map((item, i) => (
                    // <Col lg={3} md={4} sm={6} className="projColImg" key={i}>
                        <Box
                            className="projImg"
                            onClick={() => {
                            setIndex(i);
                            setOpen(true);
                            }}
                        >
                            <img src={item.src} alt="project" />
                        </Box>
                    // </Col>
                ))}
            </Slider>
        </Row>
        <Row>
            <Slider className='align-items-center justify-content-evenly p-0' {...settings2}>
                {BrandDataConfig2.map((item, i) => (
                    // <Col lg={3} md={4} sm={6} className="projColImg" key={i}>
                        <Box
                            className="projImg"
                            onClick={() => {
                            setIndex(i);
                            setOpen2(true);
                            }}
                        >
                            <img src={item.src} alt="project" />
                        </Box>
                    // </Col>
                ))}
            </Slider>
        </Row>
        <Lightbox
          open={open}
          close={() => setOpen(false)}
          slides={slides}
          index={index}
          // plugins={[Thumbnails]}
        />
        <Lightbox
          open={open2}
          close={() => setOpen2(false)}
          slides={slides2}
          index={index}                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                 w
          // plugins={[Thumbnails]}
        />
      </ProjWapper>
    </ProjWrp>
  );
};

const ProjWrp = styled.div``;
const TransformWapper = styled.section`
  padding-bottom: 60px;
  padding-top: 80px;
  background-image: url(${OurProjectBg});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  .projH {
    text-align: left;
    padding-bottom: 20px;
    padding-right: 270px;
    margin-left: 0;
    margin-right: auto;
  }
  .projTxt {
    font-size: 20px;
    font-weight: var(--semiBold);
    text-align: right;
  }
  .projDescRow {
    align-items: center;
  }

  & > .container {
    .transformRow {
      margin-left: 0;
      margin-right: 0;
    }
    .transformColMain {
      position: relative;
      display: flex;
      align-items: center;
      height: 395px;
      padding-left: 650px;

      .transformContent {
        display: flex;
        width: 545px;
        flex-wrap: wrap;
        flex-direction: column;
        padding-left: 0;
      }
      .ceoImg {
        position: absolute;
        left: 130px;
        bottom: 0px;
      }
    }
  }
  body.rtl & {
    .projH {
      text-align: right;
      padding-right: 0;
      margin-right: 0;
      margin-left: auto;
    }
    .projTxt {
      font-size: 36px;
      font-family: var(--arSemiBold);
    }
    & > .container {
      /* .transformRow{
                margin-left: 0;
                margin-right: 0;
            } */
      .transformColMain {
        padding-left: calc(var(--bs-gutter-x) * 0.5);
        padding-right: 650px;

        .transformContent {
          width: 545px;
          /* padding-left: 0;
                    padding-right: 0; */
        }
        .ceoImg {
          position: absolute;
          left: auto;
          right: 130px;
        }
      }
    }
  }

  @media (max-width: 1399px) {
  }
  @media (max-width: 1299px) {
    & > .container {
      .transformColMain {
        padding-left: 550px;
        .transformContent {
          /* width: 545px; */
        }
        .ceoImg {
          left: 0;
        }
      }
    }
    body.rtl & {
      & > .container {
        .transformColMain {
          padding-right: 550px;

          .ceoImg {
            right: 0;
          }
        }
      }
    }
  }
  @media (max-width: 1199px) {
    & > .container {
      .transformColMain {
        padding-left: 500px;
        .transformContent {
          width: 450px;
        }
        .ceoImg {
          left: 0;
        }
      }
    }
    body.rtl & {
    }
  }
  @media (max-width: 991px) {
    & > .container {
      .transformColMain {
        padding: 0;
        .transformContent {
          width: 100%;
          padding: 0px 20px 0 20px;
        }
        .ceoImg {
          display: none;
        }
      }
    }
    .projH {
      font-size: 40px;
    }
    .projTxt {
      text-align: left;
    }
    body.rtl & {
      & > .container {
        .transformColMain {
          padding: 0;
          .transformContent {
            width: 100%;
            padding: 0px 20px 0 20px;
          }
          .ceoImg {
            display: none;
          }
        }
      }
      .projH {
        text-align: right;
        padding-right: 0;
        font-size: 60px;
      }
      .projTxt {
        text-align: right;
        font-size: 30px;
      }
    }
  }
  @media (max-width: 767px) {
    & > .container {
      .transformColMain {
        height: auto;
        padding-top: 50px !important;
        padding-bottom: 50px !important;
        .transformContent {
          width: 100%;
          padding-left: 5px;
          padding-right: 5px;
          .transformTxt {
            font-size: 18px;
          }
        }
      }
    }
    body.rtl & {
      & > .container {
        .transformColMain {
          .transformContent {
            padding-left: 5px;
            padding-right: 5px;
          }
        }
      }
      .projH {
        font-size: 50px;
      }
    }
  }
  @media (max-width: 640px) {
  }
  @media (max-width: 575px) {
  }
  @media (max-width: 350px) {
  }
`;

const ProjWapper = styled.section`
  .projColImg {
    padding: 0;
  }
  .projImg {
    cursor: pointer;
     height: 100%;
    img{
width: 100%;
    height: 100%;
    }
    
    span {
      width: 100%;
      img {
        width: 100%;
      }
    }
  }
`;

export default Projects;
